import { render, staticRenderFns } from "./HomeMainVideoCard.vue?vue&type=template&id=0ecf7726&scoped=true&"
import script from "./HomeMainVideoCard.vue?vue&type=script&lang=ts&"
export * from "./HomeMainVideoCard.vue?vue&type=script&lang=ts&"
import style0 from "./HomeMainVideoCard.vue?vue&type=style&index=0&id=0ecf7726&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecf7726",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseImage: require('/codebuild/output/src2039654861/src/threease_lp/components/shared/Base/BaseImage.vue').default})
